<div [formGroup]="form">
  <div class="section-container" id="servicos">
    <div class="section-title">
      <mat-icon>description</mat-icon>
      <span>Serviços</span>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Descrição</mat-label>
          <textarea matInput formControlName="descricaoServico" rows="3" placeholder="Descreva o serviço tomado conforme a nota"></textarea>
          @if (form.get('descricaoServico')?.hasError('required') && form.get('descricaoServico')?.touched) {
          <mat-error>Campo obrigatório</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor (R$)</mat-label>
          <input matInput formControlName="valorServico" [currencyMask]="dynamicCurrencyMask" />
          @if (form.get('valorServico')?.hasError('required') && form.get('valorServico')?.touched) {
          <mat-error>Campo obrigatório</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-5">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Natureza da Base de Cálculo do Crédito</mat-label>
          <mat-select formControlName="codigoNaturezaBaseCalculoCreditoSped">
            <mat-option [value]="null">Selecione...</mat-option>
            @for (opcao of naturezaOpcoes; track opcao.codigo) {
            <mat-option [value]="opcao.codigo">{{ opcao.codigo }} - {{ opcao.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Origem do Crédito</mat-label>
          <mat-select formControlName="codigoOrigemCreditoSped">
            <mat-option [value]="null">Selecione...</mat-option>
            @for (opcao of origemCreditoOpcoes; track opcao.codigo) {
            <mat-option [value]="opcao.codigo">{{ opcao.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
